// extracted by mini-css-extract-plugin
module.exports = {"showRoom":"menuShops_showRoom__2RqGP"};